import { CircleCheckBig } from "lucide-react";
import { PHOTO_ABOUT, waLink } from "../../lib/constants";
import useReveal from "../../hooks/useReveal";

const CREDENCIAIS = [
  "Cirurgião Torácico especializado em Derrame Pleural",
  "Título de Especialista em Cirurgia Torácica emitido pela Sociedade Brasileira de Cirurgia Torácica (SBCT)",
  "Expertise em técnicas minimamente invasivas (pleuroscopia / VATS)",
  "Atualização científica constante em protocolos de manejo de Derrame Pleural",
  "Atua nos melhores hospitais de Feira de Santana - BA",
  "Acompanhamento multidisciplinar: pneumologistas, cardiologistas, oncologistas e radiologistas",
  "Abordagem humanizada e baseada em evidências científicas",
];

export default function Sobre() {
  const { ref, isVisible } = useReveal();

  return (
    <section
      id="sobre"
      ref={ref}
      className={`py-24 md:py-32 bg-white reveal-section ${isVisible ? "is-visible" : ""}`}
      data-testid="sobre-section"
    >
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="relative flex justify-center">
            <div className="relative w-full max-w-xl">
              <div className="aspect-[4/5] rounded-3xl overflow-hidden shadow-xl flex items-center justify-center bg-gray-50">
                <img
                  alt="Dr. Mateus Marques - Cirurgião Torácico em Feira de Santana"
                  className="w-full h-full object-contain"
                  loading="lazy"
                  src={PHOTO_ABOUT}
                />
              </div>
              <div className="absolute -bottom-6 -right-6 bg-[#0D47A1] text-white rounded-2xl p-5 shadow-xl">
                <div className="font-poppins font-bold text-2xl">SBCT</div>
                <div className="text-white/75 text-xs font-medium">Especialista em Cirurgia Torácica</div>
              </div>
              <div className="absolute top-6 -left-6 bg-[#00897B] text-white rounded-2xl p-4 shadow-xl hidden lg:block">
                <div className="font-poppins font-bold text-xl">CRM-BA</div>
                <div className="text-white/80 text-xs">28.632</div>
              </div>
            </div>
          </div>

          <div>
            <div className="inline-flex items-center bg-[#00897B]/10 text-[#00897B] rounded-full px-4 py-1.5 text-sm font-semibold mb-4">
              Autoridade do Cirurgião
            </div>
            <h2 className="font-poppins font-bold text-3xl sm:text-4xl text-[#212121] mb-6 leading-tight">
              Em Quem Você Confia para Tratar Seu Derrame Pleural
            </h2>
            <p className="text-base md:text-lg text-[#212121]/75 leading-relaxed mb-4">
              O Dr. Mateus Marques é Cirurgião Torácico especializado em diagnóstico e tratamento de
              derrame pleural, com atuação nos maiores hospitais de Feira de Santana - BA.
            </p>
            <p className="text-base md:text-lg text-[#212121]/75 leading-relaxed mb-4">
              E o diferencial vai além da técnica. Ele trabalha em conjunto com pneumologistas,
              cardiologistas e oncologistas, formando uma equipe multidisciplinar para conduzir seu caso
              com todo o cuidado que você merece. Derrame pleural não é apenas um achado radiológico —
              é uma condição que exige diagnóstico da causa subjacente. E aqui você encontra todo o
              suporte.
            </p>
            <p className="text-base md:text-lg text-[#212121]/75 leading-relaxed mb-8">
              Uma das principais áreas de atuação do Dr. Mateus é justamente o diagnóstico e tratamento
              de derrame pleural. Se você foi diagnosticado com derrame, está no lugar certo.
            </p>
            <ul className="space-y-3 mb-8">
              {CREDENCIAIS.map((item, idx) => (
                <li key={idx} className="flex items-start gap-3" data-testid={`credencial-${idx + 1}`}>
                  <CircleCheckBig size={20} className="text-[#00897B] mt-0.5 flex-shrink-0" />
                  <span className="text-[#212121]/80 text-sm md:text-base">{item}</span>
                </li>
              ))}
            </ul>
            <a
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="sobre-cta-button"
              className="inline-flex items-center gap-2 bg-[#0D47A1] text-white font-poppins font-bold px-8 py-4 rounded-full hover:bg-[#00897B] transition-colors duration-200 shadow-lg hover:-translate-y-0.5 hover:shadow-xl"
            >
              AGENDAR CONSULTA COM ESPECIALISTA
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
